import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import PageHeaderBreadcrumbs from './PageHeaderBreadcrumbs'

type TProps = {
  title: string
  toolbarChildren?: ReactNode
}
export default function PageHeader(props: TProps) {
  const { title, toolbarChildren } = props

  return (
    <Stack direction="column" mb={4}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h1">{title}</Typography>
        <Stack direction="row" spacing={1}>
          {toolbarChildren}
        </Stack>
      </Stack>
      <PageHeaderBreadcrumbs />
    </Stack>
  )
}
